export const SCROLL_DELAY_MS = 120;
